import { createSelector, createSlice } from '@reduxjs/toolkit'

interface IsState {
  language: string
  theme: string
  date: Date | undefined
  deviceId: string
  page: number
}

const initialState: IsState = {
  language: 'fa',
  theme: 'dark',
  date: undefined,
  deviceId: '',
  page: 0,
}

const slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    languageSet: (ui, action) => {
      ui.language = action.payload
    },
    themeSet: (ui, action) => {
      ui.theme = action.payload
    },
    dateAndDeviceIdSet: (ui, action) => {
      ui.date = action.payload.date
      ui.deviceId = action.payload.deviceId
    },
    dateAndDeviceIdReset: (ui) => {
      ui.date = undefined
      ui.deviceId = ''
    },
    pageSet: (ui, action) => {
      ui.page = action.payload
    },
  },
})

export const setPages = (page: number) => (dispatch: any) => {
  dispatch({
    type: slice.actions.pageSet.type,
    payload: page,
  })
}
export const setLanguage = (language: string) => (dispatch: any) => {
  dispatch({
    type: slice.actions.languageSet.type,
    payload: language,
  })
}

export const setTheme = (theme: string) => (dispatch: any) => {
  dispatch({
    type: slice.actions.themeSet.type,
    payload: theme,
  })
}

export const setDateAndDeviceId = (payload: object) => (dispatch: any) => {
  dispatch({
    type: slice.actions.dateAndDeviceIdSet.type,
    payload,
  })
}

export const resetDateAndDeviceId = () => (dispatch: any) => {
  dispatch({
    type: slice.actions.dateAndDeviceIdReset.type,
  })
}

export const getLanguage = createSelector(
  (state: any) => state.ui,
  (ui: any) => ui.language,
)

export const getTheme = createSelector(
  (state: any) => state.ui,
  (ui: any) => ui.theme,
)
export const getDate = createSelector(
  (state: any) => state.ui,
  (ui: any) => ui.date,
)

export const getDeviceId = createSelector(
  (state: any) => state.ui,
  (ui: any) => ui.deviceId,
)
export const getPage = createSelector(
  (state: any) => state.ui,
  (ui: any) => ui.page,
)

export default slice.reducer
